module.exports = __webpack_public_path__ + "img/airline-mobile-en.8101c48d.png";